import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { isStaff } from '@/utils/type-guards'

const TERMS_OF_SERVICE_URL = 'https://promotal-medconnect.com/terms-of-services'
const INTEREST_LINKS_URL = 'https://promotal-medconnect.com/liens-interet'

export type FooterProps = {}

export function Footer(props: FooterProps) {
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)
  const isStaffUser = isStaff(authUser)

  const linkSx = {
    color: 'text.secondary',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  }

  return (
    <Box
      component="footer"
      role="contentinfo"
      sx={{
        px: 2,
        py: 1,
        textAlign: 'center',
        fontSize: 12,
        color: 'text.secondary',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Stack direction="row" spacing={1} divider={<Typography variant="caption">|</Typography>} justifyContent="center" alignItems="center" flexWrap="wrap">
        <Typography variant="caption">&copy; {new Date().getFullYear()} Medconnect</Typography>
        {isStaffUser && (
          <MuiLink component={RouterLink} to="/sitemap" variant="caption" sx={linkSx}>
            {t('common:sitemap.title', { defaultValue: 'Sitemap' })}
          </MuiLink>
        )}
        {isStaffUser && (
          <MuiLink component={RouterLink} to="/accessibility" variant="caption" sx={linkSx}>
            {t('common:accessibility.title', { defaultValue: 'Accessibility' })}
          </MuiLink>
        )}
        <MuiLink component={RouterLink} to="/ai-transparency" variant="caption" sx={linkSx}>
          {t('common:aiTransparency.title', { defaultValue: 'AI Transparency' })}
        </MuiLink>
        <MuiLink href={TERMS_OF_SERVICE_URL} target="_blank" rel="noopener noreferrer" variant="caption" sx={linkSx}>
          {t('common:termsOfService.title', { defaultValue: 'Terms of service' })}
        </MuiLink>
        <MuiLink href={INTEREST_LINKS_URL} target="_blank" rel="noopener noreferrer" variant="caption" sx={linkSx}>
          {t('common:interestLinks.title', { defaultValue: 'Interest links' })}
        </MuiLink>
      </Stack>
    </Box>
  )
}
